import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { AudioService } from '../../../audio/audio.service';
import { ADPolicyState } from 'src/app/constants/ad-policy.constants';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Injectable({
	providedIn: 'root'
})
export class AudioDefaultValueService {

	constructor(private audioService: AudioService, private logger: LoggerService) { }

	initialize(adTags: any) {
		const audioSmartSettingsValue = _.get(adTags, DeviceSettingsFeatureToggle.AudioSmartSettings);
		if (audioSmartSettingsValue === ADPolicyState.ENABLED) {
			this.setAudioSmartSettingsDefaultValue();
		}
	}

	private async setAudioSmartSettingsDefaultValue() {
		try {
			const dolbyModeResponse = await this.audioService.getDolbyMode();
			this.logger.info('AudioDefaultValueService - setAudioSmartSettingsDefaultValue - getDolbyMode', dolbyModeResponse);

			if (dolbyModeResponse?.available) {
				this.setDolbyDefaultValue(true);
				this.setVoip(true);
			}
		} catch (error) {
			this.logger.error('AudioDefaultValueService - setAudioSmartSettingsDefaultValue - getDolbyMode', error);
		}
	}

	private async setDolbyDefaultValue(defaultValue: boolean) {
		this.logger.info('AudioDefaultValueService - setDolbyDefaultValue');

		const featureStatus = await this.audioService.getDolbyFeatureStatus();
		const isNotUndefined = !_.isUndefined(featureStatus?.status);
		const isNotDefaultValue = featureStatus?.status !== defaultValue;

		this.logger.info('AudioDefaultValueService - setDolbyDefaultValue - Feature & Default Values', { featureStatus, isNotUndefined, isNotDefaultValue, defaultValue });

		if (isNotUndefined && isNotDefaultValue) {
			try {
				this.audioService.setDolbyOnOff(defaultValue);
			} catch (error) {
				this.logger.error('AudioDefaultValueService - setDolbyDefaultValue - setDolbyOnOff', error);
			}
		}
	}

	private async setVoip(defaultValue: boolean) {
		this.logger.info('AudioDefaultValueService - setVoip');
		this.audioService.getMicrophoneSettingsAsync((result) => {
			this.logger.info('AudioDefaultValueService - setVoip - getMicrophoneSettingsAsync', result);
			if (result.hasOwnProperty('autoOptimization') && !result.autoOptimization) {
				try {
					this.audioService.setMicrophoneAutoOptimization(defaultValue);
				} catch (error) {
					this.logger.error('AudioDefaultValueService - setVoip - setMicrophoneAutoOptimization', error);
				}
			}
		});
	}
}
